
import { defineComponent } from 'vue'
import { FilterOperator } from 'primevue/api'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import datasetPreviewTableDescriptor from './DatasetPreviewTableDescriptor.json'

export default defineComponent({
    name: 'function-catalog-preview-table',
    components: { Column, DataTable },
    props: { previewColumns: { type: Array }, previewRows: { type: Array }, pagination: { type: Object }, previewType: String },
    emits: ['pageChanged', 'sort', 'filter'],
    data() {
        return {
            datasetPreviewTableDescriptor,
            columns: [] as any[],
            rows: [] as any[],
            filters: { global: [filterDefault] } as Object,
            globalFilterFields: [] as string[],
            lazyParams: {} as any,
            sorted: 'ASC',
            timer: null as any,
            searchInput: {} as any,
            searchVisible: {} as any,
            customFilters: [] as any,
            first: 0
        }
    },
    watch: {
        previewColumns() {
            this.loadColumns()
        },
        previewRows() {
            this.loadRows()
        },
        pagination() {
            this.loadPagination()
        }
    },
    created() {
        this.loadColumns()
        this.loadRows()
        this.loadPagination()
    },
    methods: {
        loadColumns() {
            this.columns = []
            this.previewColumns?.forEach((el: any) => {
                this.columns.push(el)
                this.globalFilterFields.push(el.field)
                this.filters[el.field] = { operator: FilterOperator.AND, constraints: [filterDefault] }
            })
        },
        loadRows() {
            this.rows = this.previewRows as any[]
        },
        loadPagination() {
            this.lazyParams = this.pagination as any
        },
        onPage(event: any) {
            this.lazyParams = { paginationStart: event.first, paginationLimit: event.rows, paginationEnd: event.first + event.rows, size: this.lazyParams.size }
            this.$emit('pageChanged', this.lazyParams)
        },
        onSort(event: any) {
            let column = ''
            const index = this.columns.findIndex((el: any) => el.field === event.sortField)
            if (index !== -1) {
                column = this.columns[index].header
            }
            const order = event.sortOrder === 1 ? 'asc' : 'desc'
            this.$emit('sort', { column: column, order: order })
        },
        onFilter(column: any) {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }

            this.timer = setTimeout(() => {
                const filter = { column: column.header, value: this.searchInput[column.field] }
                const index = this.customFilters.findIndex((el: any) => el.column === column.header)

                if (index !== -1) {
                    if (!filter.value) {
                        this.customFilters.splice(index, 1)
                    } else {
                        this.customFilters[index] = filter
                    }
                } else {
                    this.customFilters.push(filter)
                }
                this.$emit('filter', this.customFilters)
            }, 1000)
        }
    }
})
